import { render, staticRenderFns } from "./loginModel.vue?vue&type=template&id=82db9478&scoped=true"
import script from "./loginModel.vue?vue&type=script&lang=js"
export * from "./loginModel.vue?vue&type=script&lang=js"
import style0 from "./loginModel.vue?vue&type=style&index=0&id=82db9478&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82db9478",
  null
  
)

export default component.exports